/**--external-- */
import React from "react";
import classNames from "classnames";
import { Tooltip, useDSContext } from "@toddle-edu/ds-web";

/**--relative-- */
import classes from "./OrganizationBasicDetails.scss";

const OrganizationBasicDetails = props => {
  const { profileImage, name, id, isDisabled } = props;
  const { dsVersion } = useDSContext();
  const organizationNameClasses = classNames(classes.name, {
    [classes.disabledOrganizationName]: isDisabled,
    ["text-body"]: dsVersion === "2.0",
    ["text-body-1"]: dsVersion === "1.0",
  });

  const organizationIdClasses = classNames(classes.id, {
    [classes.disabledOrganizationId]: isDisabled,
    ["text-body-s"]: dsVersion === "2.0",
    ["text-body-3"]: dsVersion === "1.0",
  });

  return (
    <div className={classes.container}>
      <figure className={classes.figure}>
        <img src={profileImage} alt={`${name} logo`} />
      </figure>
      <div className={classes.rightContent}>
        <Tooltip tooltip={name} placement="topLeft">
          <p className={organizationNameClasses}>{name}</p>
        </Tooltip>
        <p className={organizationIdClasses}>{id}</p>
      </div>
    </div>
  );
};

export default OrganizationBasicDetails;

OrganizationBasicDetails.displayName = "OrganizationBasicDetails";
